import { useCallback, useState } from "react";

const useDialog = (initialData = null) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(initialData);

  const open = useCallback((dialogData = null) => {
    if (dialogData) {
      setData(dialogData);
    }
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setData(initialData);
  }, [initialData]);

  return {
    isOpen,
    open,
    close,
    data,
    setData,
  };
};

export default useDialog;
